<form [formGroup]="contatoForm" id="contatoForm" #formElement (ngSubmit)="salvar()">
  <div class="row g-3">

    <ng-container *ngIf="!paginaEntidade">
      <!-- <ng-container *ngIf="vinculo">
        <div class="col-12 form-group mb-3">
          <label for="escolherContato" class="form-label required">Selecione um contato existente</label>
          <nz-select formControlName="escolherContato" nzShowSearch nzAllowClear
            nzPlaceHolder="Selecionar contato existente" nzSize="large" [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato"
              *ngFor="let item of tipoContatoList"></nz-option>
          </nz-select>
        </div>

        <nz-divider></nz-divider>
      </ng-container> -->

      <div class="col-12 form-group" *ngIf="!paginaPessoa">
        <label nz-checkbox formControlName="flagPrincipal" (ngModelChange)="checkIfPrincipal($event)">Principal</label>
      </div>

      <div class="col form-group">
        <label for="tipoContato" class="form-label required">Tipo de Contato</label>
        <nz-select formControlName="tipoContato" (ngModelChange)="onTipoContatoChange($event)" nzShowSearch nzAllowClear
          nzPlaceHolder="Tipo de Contato" nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato" *ngFor="let item of tipoContatoList"></nz-option>
        </nz-select>
      </div>
    </ng-container>

    <ng-container *ngIf="paginaVinculo">


      <div class="col form-group" *ngIf="showPessoaDelegada">
        <label for="pessoaDelegadaId" class="form-label">Pessoa Delegada</label>
        <nz-select id="pessoaDelegadaId" nzShowSearch nzServerSearch nzPlaceHolder="Selecione a pessoa"
          formControlName="pessoaDelegadaId" [nzShowArrow]="false" [nzFilterOption]="nzFilterOption" nzSize="large"
          [nzAllowClear]="true">
          <!-- (nzOnSearch)="loadEntidadesSuperior($event)"> -->
          <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of nomePessoaList"></nz-option>
        </nz-select>
      </div>
    </ng-container>


    <div class="col-12 col-sm-2 form-group">
      <label for="pais" class="form-label" [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">País</label>
      <nz-select formControlName="pais" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareFn">
        <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of paisesList" />
      </nz-select>
    </div>

    <div class="col-12 col-sm-2 form-group" *ngIf="!cepToZipCode">
      <label for="enderecoCep" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">CEP</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoCep" formControlName="enderecoCep" placeholder="CEP" mask="00000-000" [ngModel]="cep"
          (ngModelChange)="cep = $event" (focusout)="onCepBlur()" />
      </nz-input-group>
    </div>

    <div class="col-12 col-sm-2 form-group">
      <label for="enderecoUf" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Estado</label>
      <nz-select formControlName="enderecoUf" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareFn">
        <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of ufList" />
      </nz-select>
    </div>

    <div class="col-12 col-sm-3 form-group">
      <label for="enderecoMunicipio" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Cidade</label>
      <nz-select formControlName="enderecoMunicipio" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareFn" [maxlength]="150">
        <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of cidadeList" />
      </nz-select>
    </div>

    <div class="col-12 col-sm-3 form-group">
      <label for="enderecoBairro" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Bairro</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoBairro" formControlName="enderecoBairro" placeholder="Bairro" [maxlength]="150" />
      </nz-input-group>

      <!-- <nz-select formControlName="enderecoBairro" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareFn">
        <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of bairrosList" />
      </nz-select> -->
    </div>

    <div class="col-12 col-sm-6 form-group">
      <label for="enderecoLogradouro" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Logradouro</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoLogradouro" formControlName="enderecoLogradouro" placeholder="Logradouro"
          nzSearch [maxlength]="150" />
      </nz-input-group>
    </div>
    <div class="col-12 col-sm-2 form-group">
      <label for="enderecoNumero" class="form-label">Número</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoNumero" formControlName="enderecoNumero" placeholder="Número" nzSearch [maxlength]="50" />
      </nz-input-group>
    </div>
    <div class="col-12 col-sm-4 form-group">
      <label for="enderecoComplemento" class="form-label">Complemento</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoComplemento" formControlName="enderecoComplemento" placeholder="Complemento"
          nzSearch [maxlength]="255" />
      </nz-input-group>
    </div>



    <div class="col-12 col-sm-3 form-group" *ngIf="cepToZipCode">
      <label for="enderecoCep" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">ZIP CODE</label>
      <nz-input-group nzSize="large">
        <input nz-input id="enderecoCep" formControlName="enderecoCep" placeholder="ZIP CODE" mask="00000-0000" />
      </nz-input-group>
    </div>

    <div class="col-sm-2 form-group">
      <label for="ddi" class="form-label">DDI</label>
      <nz-select formControlName="ddi" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareFn">
        <nz-option *ngFor="let item of ddiList" [nzValue]="item.ddi"
          [nzLabel]="item.nome + ' ' + (item.ddi)"></nz-option>
      </nz-select>
    </div>
    <div class="col-sm-2 form-group">
      <label for="telefone" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.TELEFONE">Telefone</label>
      <nz-input-group nzSize="large">
        <input nz-input formControlName="telefone" placeholder="(xx) xxxx-xxxx" mask="(00) 0000-0000 || (00) 0 0000-0000" />
        <!-- <div
          *ngIf="contatoForm.get('telefone')?.invalid && (contatoForm.get('telefone')?.dirty || contatoForm.get('telefone')?.touched)">
          <div *ngIf="contatoForm.get('telefone')?.errors?.['required']" class="text-danger">Telefone é obrigatório.
          </div>
          <div *ngIf="contatoForm.get('telefone')?.errors?.['telefone']" class="text-danger">Telefone inválido.</div>
          <div *ngIf="contatoForm.get('telefone')?.errors?.['pattern']" class="text-danger">Formato do Telefone
            inválido.</div>
        </div> -->
      </nz-input-group>
    </div>

    <div class="col-5 form-group">
      <label for="telefoneAdicional" class="form-label">Outros Telefones</label>
      <nz-input-group nzSize="large">
        <input nz-input id="telefoneAdicional" formControlName="telefoneAdicional" placeholder="Outros Telefones" />
      </nz-input-group>
    </div>

    <div class="col-sm-5 form-group">
      <label for="email" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.EMAIL || tipoContatoId == tipoContatoEnum.EMAILAREAJURIDICA">E-mail</label>
      <app-email-search-select formControlName="email" placeholder="E-mail"></app-email-search-select>
      <div
        *ngIf="contatoForm.get('email')?.invalid && (contatoForm.get('email')?.dirty || contatoForm.get('email')?.touched)">
        <div *ngIf="contatoForm.get('email')?.errors?.['required']" class="text-danger">E-mail é obrigatório.</div>
      </div>
    </div>

    <!--<div class="col-7 form-group">
      <label for="informacoesAdicionais" class="form-label">E-mail Geral</label>
      <nz-input-group nzSize="large">
        <input nz-input id="informacoesAdicionais" formControlName="informacoesAdicionais" placeholder="E-mail Geral" />
      </nz-input-group>
    </div>-->

    <div class="col-12 form-group" *ngIf="paginaEntidade">
      <label for="siteUrl" class="form-label">Site</label>
      <nz-input-group nzSize="large">
        <input nz-input formControlName="siteUrl" placeholder="Url Site" [maxlength]="150" />
      </nz-input-group>
    </div>
  </div>
</form>
<ng-container *ngIf="!paginaEntidade">
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="default" class="me-3" (click)="reset()">Limpar</button>
      <button nz-button nzType="primary" type="submit" form="contatoForm">{{ inserir ? 'Adicionar': 'Editar' }}</button>
    </div>
  </div>
</ng-container>
